
define('text!views/VisualAnalytics/AnalyticsReport.html',[],function () { return '<section class="content-header">\r\n    <h1>Analytics Report </h1>\r\n</section>\r\n\r\n<div id="eRD_Report" style="display: block; width: 100%; height:100%"></div>\r\n\r\n';});

